/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Observable } from 'rxjs';
import { CheckState } from '../../enum/check-state.enum';
import { DropdownDirectionEnum } from '../../enum/dropdown-direction-enum.type';
import { DropdownGroupAction } from './dropdown-group-action';
import { SimpleAction } from './simple-action';
import { StandardAction } from './standard-action';

export class DropdownAction extends SimpleAction<StandardAction[]> {
  set datasource$(value: Observable<StandardAction[]>) {
    this._datasource$ = value;
    if (value) {
      value.subscribe((data) => {
        this.items = data;
      });
    }
  }
  public isOpen: boolean;
  public isGroup: boolean;
  public multiDropdown: boolean;

  public selectedValues: {
    check: boolean;
    preselect: boolean;
    value: DropdownGroupAction;
  }[] = [];

  public lastChange: { check: boolean; value: any };
  private _datasource$: Observable<StandardAction[]>;

  public displayData: StandardAction[];
  public items: StandardAction[];
  public preselectItem: StandardAction;
  public preselectIndex: number;

  public isMultiple: boolean;
  public withSearch: boolean;
  public direction: DropdownDirectionEnum = 'down';

  public selection: CheckState;

  constructor(
    name: string,
    icon: string,
    dataSource: Observable<StandardAction[]>,
    text?: string,
    multiDropdown = false,
  ) {
    super(name, icon, null, text);
    this.category = 'dropdown';
    this.multiDropdown = multiDropdown;
    this.datasource$ = dataSource;
  }

  setData(data: StandardAction[]) {
    this.items = data;
    this.checkSelection();
  }

  public resetPreselection() {
    if (this.preselectItem) {
      // this.preselectItem.preselect = false;
      this.preselectItem = null;
      this.preselectIndex = -1;
    }
  }

  switch(item: { check: boolean; value: any }) {
    if (item.check) {
      this.removeValue(item.value);
    } else {
      this.selectedValues.push(item.value);
    }
    this.lastChange = item;
  }

  /***
   * remove value in selectedValues
   * it's for multiple comboAction
   * @param value
   */
  removeValue(value: any) {
    const index = this.selectedValues.indexOf(value);
    if (index >= 0) {
      this.selectedValues.splice(index, 1);
    }
  }

  override getActionType(): string {
    return 'dropdown';
  }

  changeValue(
    group: DropdownGroupAction,
    value: { check: boolean; preselect: boolean; value: DropdownGroupAction },
  ) {
    this.switch({ check: value.check, value: value });
  }

  public checkSelection() {
    const countSelection = this.items.filter((d) => d.check).length;
    switch (countSelection) {
      case 0:
        this.selection = CheckState.uncheck;
        break;
      case this.items.length:
        this.selection = CheckState.check;
        break;
      default:
        this.selection = CheckState.partial;
    }
  }

  private checkSelectionValue(
    value: boolean,
    select: 'partial' | boolean,
  ): boolean | 'partial' {
    if (select === undefined || value === select) {
      return value;
    } else {
      return 'partial';
    }
  }

  getRowCount(): number {
    let count = 0;
    for (const item of this.items) {
      if (item instanceof DropdownGroupAction) {
        count += item.items.length + 1;
      } else {
        ++count;
      }
    }
    return count;
  }

  /**
   * clear selection in dropdown
   * @private
   */
  // private clearSelection() {
  //   this.selectedValues.forEach(action => {
  //     action.check = false;
  //     action.value.check = false;
  //   });
  // }

  public selectItem(action: StandardAction, changeIcon = false) {
    this.items.forEach((it) => {
      it.check = it.name === action.name;
      if (changeIcon && it.name === action.name) {
        this.icon = it.icon;
      }
    });
  }
}
